















import Vue from "vue";
import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";

@Component({
  components: {}
})
export default class CasinoEntranceButton extends Vue {}
